import AoneService from "../axiosbase";

//Products
//get products
export const getProducts = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/products/" + params);
  } catch (error) {
    return error;
  }
};

//filter products
export const filterProducts = async (params) => {
  try {
    return await AoneService.get("/masters/api/v1/products/filter" + params);
  } catch (error) {
    return error;
  }
};

//GET productsbyid
export const getProductsbyId = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/products/" + params);
  } catch (error) {
    return error;
  }
};

//post products
export const postProducts = async (data) => {
  try {
    return await AoneService.post("masters/api/v1/products/", data);
  } catch (error) {
    return error;
  }
};

//edit products
export const editProducts = async (params, data) => {
  try {
    return await AoneService.put(`masters/api/v1/products/${params}`, data);
  } catch (error) {
    return error;
  }
};

//patch Products
export const editProductsbypatch = async (params, data) => {
  try {
    return await AoneService.patch(`masters/api/v1/products/${params}`, data);
  } catch (error) {
    return error;
  }
};

//retreive Products DimensionUnit
export const getProductsDimension = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/DimensionUnit");
  } catch (error) {
    return error;
  }
};

//retreive Products ChangeProductEvent
export const getProductsEvent = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/ChangeProductEvent");
  } catch (error) {
    return error;
  }
};

//retreive Products WeightUnit
export const getProductsWeight = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/WeightUnit");
  } catch (error) {
    return error;
  }
};

//retreive Products ProductCategory
export const getProductCategory = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/ProductCategory");
  } catch (error) {
    return error;
  }
};

//retreive Products ContentType
export const getProductsContent = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/ContentType");
  } catch (error) {
    return error;
  }
};

//delete hubs
export const deleteProducts = async (params) => {
  try {
    return await AoneService.delete("masters/api/v1/products/" + params);
  } catch (error) {
    return error;
  }
};

//exportProducts
export const exportProducts = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/products/export" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//Products template
export const getProductsTemplate = async () => {
  try {
    return await AoneService.get("masters/api/v1/products/template/download", {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//Products import
export const importProducts = async (data) => {
  try {
    return await AoneService.post(`masters/api/v1/products/import`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

//rates-freight
//get freight
export const getFreight = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/freight" + params);
  } catch (error) {
    return error;
  }
};

//GET freightbyif
export const getFreightbyId = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/freight/" + params);
  } catch (error) {
    return error;
  }
};

//post freight
export const postFreight = async (data) => {
  try {
    return await AoneService.post("masters/api/v1/rates/freight", data);
  } catch (error) {
    return error;
  }
};

//edit freight
export const editFreight = async (params, data) => {
  try {
    return await AoneService.put(
      `masters/api/v1/rates/freight/${params}`,
      data
    );
  } catch (error) {
    return error;
  }
};

//patch freight
export const editFreightsbypatch = async (params, data) => {
  try {
    return await AoneService.patch(
      `masters/api/v1/rates/freight/${params}`,
      data
    );
  } catch (error) {
    return error;
  }
};

//delete freight
export const deleteFreight = async (params) => {
  try {
    return await AoneService.delete("masters/api/v1/rates/freight/" + params);
  } catch (error) {
    return error;
  }
};

//delete freight by bulk
export const bulkFreightDelete = async (data) => {
  try {
    return await AoneService.post("masters/api/v1/rates/freight/delete", data);
  } catch (error) {
    return error;
  }
};

//update freight rate state
export const editFreightState = async (params, data) => {
  try {
    return await AoneService.patch(
      `masters/api/v1/rates/freight/state/${params}`,data);
  } catch (error) {
    return error;
  }
};

//exportfreight
export const exportrateFreight = async (params) => {
  try {
    return await AoneService.get(
      "masters/api/v1/rates/freight/export" + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//freight template
export const getFreightsTemplate = async () => {
  try {
    return await AoneService.get(
      "masters/api/v1/rates/freight/template/download",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//freight import
export const importFreight = async (data) => {
  try {
    return await AoneService.post(`masters/api/v1/rates/freight/import`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

//retreive freight CalculationType
export const getCalType = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/CalculationType");
  } catch (error) {
    return error;
  }
};

//retreive freight CollectionMethod
export const getCollectionMethod = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/CollectionMethod");
  } catch (error) {
    return error;
  }
};

export const getCalculationMethod = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/ConsignmentVolumeCalculationMethod");
  } catch (error) {
    return error;
  }
};

export const getPeriod = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/Period");
  } catch (error) {
    return error;
  }
};

//retreive freight ContentType
export const getContentType = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/ContentType");
  } catch (error) {
    return error;
  }
};

//retreive rates state
export const getStateRates = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/State");
  } catch (error) {
    return error;
  }
};

//retreive freight DeliveryStatus
export const getDeliveryStatus = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/DeliveryStatus");
  } catch (error) {
    return error;
  }
};

//retreive freight PaymentType
export const getPaymentType = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/PaymentType");
  } catch (error) {
    return error;
  }
};

//retreive freight State
export const getState = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/State");
  } catch (error) {
    return error;
  }
};

//retreive freight Structure
export const getStructure = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/Structure");
  } catch (error) {
    return error;
  }
};

//rates-rto
//get Rto
export const getRto = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/rto" + params);
  } catch (error) {
    return error;
  }
};

//GET freightbyif
export const getRtobyId = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/rto/" + params);
  } catch (error) {
    return error;
  }
};

//post freight
export const postRto = async (data) => {
  try {
    return await AoneService.post("masters/api/v1/rates/rto", data);
  } catch (error) {
    return error;
  }
};

//edit freight
export const editRto = async (params, data) => {
  try {
    return await AoneService.put(`masters/api/v1/rates/rto/${params}`, data);
  } catch (error) {
    return error;
  }
};

//patch freight
export const editRtobypatch = async (params, data) => {
  try {
    return await AoneService.patch(`masters/api/v1/rates/rto/${params}`, data);
  } catch (error) {
    return error;
  }
};

//update rto rate state
export const editRtoState = async (params, data) => {
  try {
    return await AoneService.patch(
      `masters/api/v1/rates/rto/state/${params}`,data);
  } catch (error) {
    return error;
  }
};

//delete freight
export const deleteRto = async (params) => {
  try {
    return await AoneService.delete("masters/api/v1/rates/rto/" + params);
  } catch (error) {
    return error;
  }
};

export const bulkRtoDelete = async (data) => {
  try {
    return await AoneService.post("masters/api/v1/rates/rto/delete", data);
  } catch (error) {
    return error;
  }
};

//exportfreight
export const exportrateRto = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/rto/export" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//freight template
export const getRtosTemplate = async () => {
  try {
    return await AoneService.get("masters/api/v1/rates/rto/template/download", {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//freight import
export const importRto = async (data) => {
  try {
    return await AoneService.post(`masters/api/v1/rates/rto/import`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

//cod
export const getCod = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/cod" + params);
  } catch (error) {
    return error;
  }
};

export const getCodbyId = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/cod/" + params);
  } catch (error) {
    return error;
  }
};

export const postCod = async (data) => {
  try {
    return await AoneService.post("masters/api/v1/rates/cod", data);
  } catch (error) {
    return error;
  }
};

export const editCod = async (params, data) => {
  try {
    return await AoneService.put(`masters/api/v1/rates/cod/${params}`, data);
  } catch (error) {
    return error;
  }
};

export const editCodbypatch = async (params, data) => {
  try {
    return await AoneService.patch(`masters/api/v1/rates/cod/${params}`, data);
  } catch (error) {
    return error;
  }
};

export const editCodState = async (params, data) => {
  try {
    return await AoneService.patch(
      `masters/api/v1/rates/cod/state/${params}`,data);
  } catch (error) {
    return error;
  }
};

export const deleteCod = async (params) => {
  try {
    return await AoneService.delete("masters/api/v1/rates/cod/" + params);
  } catch (error) {
    return error;
  }
};

export const bulkCodDelete = async (data) => {
  try {
    return await AoneService.post("masters/api/v1/rates/cod/delete", data);
  } catch (error) {
    return error;
  }
};

export const exportrateCod = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/cod/export" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

export const getCodrateTemplate = async () => {
  try {
    return await AoneService.get("masters/api/v1/rates/cod/template/download", {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

export const importCod = async (data) => {
  try {
    return await AoneService.post(`masters/api/v1/rates/cod/import`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

//oda
export const getOda = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/oda" + params);
  } catch (error) {
    return error;
  }
};

export const getOdabyId = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/oda/" + params);
  } catch (error) {
    return error;
  }
};

export const postOda = async (data) => {
  try {
    return await AoneService.post("masters/api/v1/rates/oda", data);
  } catch (error) {
    return error;
  }
};

export const editOda = async (params, data) => {
  try {
    return await AoneService.put(`masters/api/v1/rates/oda/${params}`, data);
  } catch (error) {
    return error;
  }
};

export const editOdabypatch = async (params, data) => {
  try {
    return await AoneService.patch(`masters/api/v1/rates/oda/${params}`, data);
  } catch (error) {
    return error;
  }
};

export const editOdaState = async (params, data) => {
  try {
    return await AoneService.patch(
      `masters/api/v1/rates/oda/state/${params}`,data);
  } catch (error) {
    return error;
  }
};

export const deleteOda = async (params) => {
  try {
    return await AoneService.delete("masters/api/v1/rates/oda/" + params);
  } catch (error) {
    return error;
  }
};

export const bulkOdaDelete = async (data) => {
  try {
    return await AoneService.post("masters/api/v1/rates/oda/delete", data);
  } catch (error) {
    return error;
  }
};

export const exportrateOda = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/oda/export" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

export const getOdarateTemplate = async () => {
  try {
    return await AoneService.get("masters/api/v1/rates/oda/template/download", {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

export const importOda = async (data) => {
  try {
    return await AoneService.post(`masters/api/v1/rates/oda/import`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

//fuel
export const getFuel = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/fuel" + params);
  } catch (error) {
    return error;
  }
};

export const getFuelbyId = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/fuel/" + params);
  } catch (error) {
    return error;
  }
};

export const postFuel = async (data) => {
  try {
    return await AoneService.post("masters/api/v1/rates/fuel", data);
  } catch (error) {
    return error;
  }
};

export const editFuel = async (params, data) => {
  try {
    return await AoneService.put(`masters/api/v1/rates/fuel/${params}`, data);
  } catch (error) {
    return error;
  }
};

export const editFuelbypatch = async (params, data) => {
  try {
    return await AoneService.patch(`masters/api/v1/rates/fuel/${params}`, data);
  } catch (error) {
    return error;
  }
};

export const editFuelState = async (params, data) => {
  try {
    return await AoneService.patch(
      `masters/api/v1/rates/fuel/state/${params}`,data);
  } catch (error) {
    return error;
  }
};

export const deleteFuel = async (params) => {
  try {
    return await AoneService.delete("masters/api/v1/rates/fuel/" + params);
  } catch (error) {
    return error;
  }
};

export const bulkFuelDelete = async (data) => {
  try {
    return await AoneService.post("masters/api/v1/rates/fuel/delete", data);
  } catch (error) {
    return error;
  }
};

export const exportrateFuel = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/fuel/export" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

export const getFuelrateTemplate = async () => {
  try {
    return await AoneService.get(
      "masters/api/v1/rates/fuel/template/download",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const importFuel = async (data) => {
  try {
    return await AoneService.post(`masters/api/v1/rates/fuel/import`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

//insurance
export const getInsurance = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/insurance" + params);
  } catch (error) {
    return error;
  }
};

export const getInsurancebyId = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/insurance/" + params);
  } catch (error) {
    return error;
  }
};

export const postInsurance = async (data) => {
  try {
    return await AoneService.post("masters/api/v1/rates/insurance", data);
  } catch (error) {
    return error;
  }
};

export const editInsurance = async (params, data) => {
  try {
    return await AoneService.put(
      `masters/api/v1/rates/insurance/${params}`,
      data
    );
  } catch (error) {
    return error;
  }
};

export const editInsurancebypatch = async (params, data) => {
  try {
    return await AoneService.patch(
      `masters/api/v1/rates/insurance/${params}`,
      data
    );
  } catch (error) {
    return error;
  }
};

export const editInsuranceState = async (params, data) => {
  try {
    return await AoneService.patch(
      `masters/api/v1/rates/insurance/state/${params}`,data);
  } catch (error) {
    return error;
  }
};

export const deleteInsurance = async (params) => {
  try {
    return await AoneService.delete("masters/api/v1/rates/insurance/" + params);
  } catch (error) {
    return error;
  }
};

export const bulkInsuranceDelete = async (data) => {
  try {
    return await AoneService.post("masters/api/v1/rates/insurance/delete", data);
  } catch (error) {
    return error;
  }
};

export const exportrateInsurance = async (params) => {
  try {
    return await AoneService.get(
      "masters/api/v1/rates/insurance/export" + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const getInsurancerateTemplate = async () => {
  try {
    return await AoneService.get(
      "masters/api/v1/rates/insurance/template/download",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const importInsurance = async (data) => {
  try {
    return await AoneService.post(
      `masters/api/v1/rates/insurance/import`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};

//attempts
export const getAttempts = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/attempts" + params);
  } catch (error) {
    return error;
  }
};

export const getAttemptsbyId = async (params) => {
  try {
    return await AoneService.get("masters/api/v1/rates/attempts/" + params);
  } catch (error) {
    return error;
  }
};

export const postAttempts = async (data) => {
  try {
    return await AoneService.post("masters/api/v1/rates/attempts", data);
  } catch (error) {
    return error;
  }
};

export const editAttempts = async (params, data) => {
  try {
    return await AoneService.put(
      `masters/api/v1/rates/attempts/${params}`,
      data
    );
  } catch (error) {
    return error;
  }
};

export const editAttemptsbypatch = async (params, data) => {
  try {
    return await AoneService.patch(
      `masters/api/v1/rates/attempts/${params}`,
      data
    );
  } catch (error) {
    return error;
  }
};

export const editAttemptsState = async (params, data) => {
  try {
    return await AoneService.patch(
      `masters/api/v1/rates/attempts/state/${params}`,data);
  } catch (error) {
    return error;
  }
};

export const deleteAttempts = async (params) => {
  try {
    return await AoneService.delete("masters/api/v1/rates/attempts/" + params);
  } catch (error) {
    return error;
  }
};

export const bulkAttemptsDelete = async (data) => {
  try {
    return await AoneService.post("masters/api/v1/rates/attempts/delete", data);
  } catch (error) {
    return error;
  }
};

export const exportrateAttempts = async (params) => {
  try {
    return await AoneService.get(
      "masters/api/v1/rates/attempts/export" + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const getAttemptsrateTemplate = async () => {
  try {
    return await AoneService.get(
      "masters/api/v1/rates/attempts/template/download",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const importAttempts = async (data) => {
  try {
    return await AoneService.post(
      `masters/api/v1/rates/attempts/import`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};

//origins
//get Origin
export const getOrigin = async (params1, params2) => {
  try {
    return await AoneService.get(
      `masters/api/v1/products/${params1}/origins` + params2
    );
  } catch (error) {
    return error;
  }
};

//filter origin
export const filterOrigin = async (params1, params2) => {
  try {
    return await AoneService.get(
      `masters/api/v1/products/${params1}/filter/origins` + params2
    );
  } catch (error) {
    return error;
  }
};

//post Origin
export const postOrigin = async (params, data) => {
  try {
    return await AoneService.post(
      `masters/api/v1/products/${params}/origins`,
      data
    );
  } catch (error) {
    return error;
  }
};

//edit Origin
export const editOrigin = async (params, params2, data) => {
  try {
    return await AoneService.put(
      `masters/api/v1/products/${params}/origins/${params2}`,
      data
    );
  } catch (error) {
    return error;
  }
};

//delete Origin
export const deleteOrigin = async (params1, params, data) => {
  try {
    return await AoneService.delete(
      `masters/api/v1/products/${params1}/origins/${params}` + data
    );
  } catch (error) {
    return error;
  }
};

//export Origin
export const exportOrigin = async (params1, params) => {
  try {
    return await AoneService.get(
      `masters/api/v1/products/${params1}/origins/export` + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//Origin template
export const getOriginTemplate = async (params) => {
  try {
    return await AoneService.get(
    `masters/api/v1/products/${params}/origin/template/download`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//Origin import
export const importOrigin = async (params, data) => {
  try {
    return await AoneService.post(
      `masters/api/v1/products/${params}/origins/import`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};

//get Destination
export const getDestination = async (params1, params2) => {
  try {
    return await AoneService.get(
      `masters/api/v1/products/${params1}/destinations/` + params2
    );
  } catch (error) {
    return error;
  }
};

export const filterDestination = async (params1, params2) => {
  try {
    return await AoneService.get(
      `masters/api/v1/products/${params1}/filter/destinations` + params2
    );
  } catch (error) {
    return error;
  }
};

//post Destination
export const postDestination = async (params, data) => {
  try {
    return await AoneService.post(
      `masters/api/v1/products/${params}/destinations`,
      data
    );
  } catch (error) {
    return error;
  }
};

//edit Destination
export const editDestination = async (params, params2, data) => {
  try {
    return await AoneService.put(
      `masters/api/v1/products/${params}/destinations/${params2}`,
      data
    );
  } catch (error) {
    return error;
  }
};

//delete Destination
export const deleteDestination = async (params1, params, data) => {
  try {
    return await AoneService.delete(
      `masters/api/v1/products/${params1}/destinations/${params}` + data
    );
  } catch (error) {
    return error;
  }
};

//export Destination
export const exportDestination = async (params1, params) => {
  try {
    return await AoneService.get(
      `masters/api/v1/products/${params1}/destinations/export` + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//Destination template
export const getDestinationTemplate = async (params) => {
  try {
    return await AoneService.get(
      `masters/api/v1/products/${params}/destinations/template/download`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//Destination import
export const importDestination = async (params, data) => {
  try {
    return await AoneService.post(
      `masters/api/v1/products/${params}/destinations/import`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};

//get transittime
export const getTransittime = async (params1, params2) => {
  try {
    return await AoneService.get(
      `masters/api/v1/products/${params1}/transit-time/` + params2
    );
  } catch (error) {
    return error;
  }
};

//post transittime
export const postTransittime = async (params, data) => {
  try {
    return await AoneService.post(
      `masters/api/v1/products/${params}/transit-time/`,
      data
    );
  } catch (error) {
    return error;
  }
};

//edit transittime
export const editTransittime = async (params, params1, data) => {
  try {
    return await AoneService.put(
      `masters/api/v1/products/${params}/transit-time/${params1}`,
      data
    );
  } catch (error) {
    return error;
  }
};

//delete transittime
export const deleteTransittime = async (params1, params) => {
  try {
    return await AoneService.delete(
      `masters/api/v1/products/${params1}/transit-time/` + params
    );
  } catch (error) {
    return error;
  }
};

//export transittime
export const exportTransittime = async (params1, params) => {
  try {
    return await AoneService.get(
      `masters/api/v1/products/${params1}/transit-time/export` + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//transittime template
export const getTransittimeTemplate = async (params) => {
  try {
    return await AoneService.get(
      `masters/api/v1/products/${params}/transit-time/template/download`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//transittime import
export const importTransittime = async (params, data) => {
  try {
    return await AoneService.post(
      `masters/api/v1/products/${params}/transit-time/import`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};
